import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const radarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true, array: true }
  ],
  businessRules: [
    {
      name: 'radar-y-array-validation',
      validator: (data, layer) => {
        if (!layer.encoding?.y || !Array.isArray(layer.encoding.y)) {
          return false;
        }
        const yCount = layer.encoding.y.length;
        return yCount > 2 && yCount <= 10;
      },
      message:
        'Radar chart "y" field must be an array with more than 2 and less than or equal to 10 items',
      suggestion: 'Provide 3-10 numeric fields for the y-axis to create an effective radar chart',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    }
  ]
};
